export const productOptions = [
    {
        label: 'Active Money SIPP (Pre-retirement)',
        value: 'preRetirement',
    },
    {
        label: 'Active Money SIPP (Post-retirement)',
        value: 'postRetirement',
    },
];

export const drawdownOptions = [
    {
        value: 'Yes',
        label: 'Yes',
    },
    {
        value: 'No',
        label: 'No',
    },
];

export const commissionTypeOptions = [
    {
        label: '£',
        value: 'amount',
    },
    {
        label: '%',
        value: 'percent',
    },
];

export const strings = {
    // Card and Step Titles
    reportDetails: 'Proposal details',
    clientDetails: 'Client details',

    // Label Names
    clientName: 'Client name',
    selectProduct: 'Select the product you are proposing',
    drawdown: 'Drawdown?',
    contributions: 'Contributions?',
    drawdownAmount: 'Annual amount',
    currencySymbol: '£',
    percentageSymbol: '%',
    drawdownValidationMessage: 'The maximum drawdown amount is 100%',
};
